import { BasicModel } from "../BasicModel";

export class BasicUserData {

    private _userName: string;
    private _loginPwd: string;
    private _loginToken: string;
    protected _userLevel: number = 1; // used for data binding
    protected _email: string = "";
    protected _userID: number = -1;
    protected _playerID: number = -1;

    public isGuest(): boolean {
        return this.playerID === -1;
    }

    public get userName(): string {
        return this._userName || "";
    }

    public get userNameSet(): boolean {
        return this._userName.length > 0 || this._userName !== "";
    }

    public set userName(value: string) {
        this._userName = value;
    }

    public get userLevel(): number {
        return this._userLevel;
    }

    public set userLevel(lvl: number) {
        if (this._userLevel !== lvl) {
            this._userLevel = lvl;
        }
    }

    public get loginPwd(): string {
        return this._loginPwd;
    }

    public set loginPwd(value: string) {
        this._loginPwd = value;
    }

    public get loginToken(): string {
        return this._loginToken;
    }

    public set loginToken(value: string) {
        this._loginToken = value;
    }

    public get email(): string {
        return this._email;
    }

    public set email(value: string) {
        this._email = value;
    }

    public get userID(): number {
        return this._userID;
    }

    public set userID(value: number) {
        this._userID = value;
    }

    public get playerID(): number {
        return this._playerID;
    }

    public /*final*/ set playerID(value: number) {
        this._playerID = value;
        BasicModel.localData.savePlayerID(value);
    }
}
